import { PromptModelErrorCode } from "#schemas";
/**
 * Wraps an HTTP Error received from the API.
 */
export class RequestError extends Error {
    status;
    body;
    headers;
    request_id;
    constructor(message, status, body, headers) {
        super("RequestError: " + message);
        this.status = status;
        this.body = body;
        this.headers = {};
        for (const [k, v] of headers.entries()) {
            this.headers[k.toLowerCase()] = v;
        }
        this.request_id = headers.get("X-Request-Id") || "";
    }
    isUnauthorized() {
        return this.status === 401;
    }
}
export function isAgentNotFound(err) {
    if (isRequestError(err)) {
        return err.status === 404;
    }
    return false;
}
export function isRequestTooLarge(code) {
    return code === PromptModelErrorCode["max-tokens-exceeded"];
}
export function isRequestError(err) {
    return err instanceof RequestError;
}
/**
 * Client-side error thrown to quickly prevent attempts to send requests
 * that will be rejected by server-side limit
 */
export class RejectInputTooLargeError extends Error {
    actual;
    max;
    constructor(actual, max) {
        super();
        this.actual = actual;
        this.max = max;
    }
}
